var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { applySearchAndReturnSortInfo, } from '../shared/context-menu/item-search-sort';
import { sdsCustomElement } from '../utilities/custom-components';
import styles from './sds-avatar.lit.scss';
const availableSizes = ['xl', 'lg', 'md', 'sm'];
/**
 *  Component is used to represent an avatar.
 *  Avatar is an image if `src` attribute is given,
 *  or anything in slot is rendered as an avatar.
 *
 *  @slot - Content which is rendered if `src` is empty.
 *
 *  @tag sds-avatar
 *
 */
let SdsAvatar = (() => {
    var _SdsAvatar_icon_accessor_storage, _SdsAvatar_initials_accessor_storage, _SdsAvatar_acronym_accessor_storage, _SdsAvatar_name_accessor_storage, _SdsAvatar_text_accessor_storage, _SdsAvatar_subtext_accessor_storage, _SdsAvatar_role_accessor_storage, _SdsAvatar_href_accessor_storage, _SdsAvatar_src_accessor_storage, _SdsAvatar_status_accessor_storage, _SdsAvatar_count_accessor_storage, _SdsAvatar_selected_accessor_storage, _SdsAvatar_disabled_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-avatar')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _instanceExtraInitializers = [];
    let _icon_decorators;
    let _icon_initializers = [];
    let _icon_extraInitializers = [];
    let _initials_decorators;
    let _initials_initializers = [];
    let _initials_extraInitializers = [];
    let _acronym_decorators;
    let _acronym_initializers = [];
    let _acronym_extraInitializers = [];
    let _name_decorators;
    let _name_initializers = [];
    let _name_extraInitializers = [];
    let _text_decorators;
    let _text_initializers = [];
    let _text_extraInitializers = [];
    let _subtext_decorators;
    let _subtext_initializers = [];
    let _subtext_extraInitializers = [];
    let _role_decorators;
    let _role_initializers = [];
    let _role_extraInitializers = [];
    let _href_decorators;
    let _href_initializers = [];
    let _href_extraInitializers = [];
    let _src_decorators;
    let _src_initializers = [];
    let _src_extraInitializers = [];
    let _status_decorators;
    let _status_initializers = [];
    let _status_extraInitializers = [];
    let _count_decorators;
    let _count_initializers = [];
    let _count_extraInitializers = [];
    let _selected_decorators;
    let _selected_initializers = [];
    let _selected_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _set_size_decorators;
    var SdsAvatar = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsAvatar_icon_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _icon_initializers, '')));
            _SdsAvatar_initials_accessor_storage.set(this, (__runInitializers(this, _icon_extraInitializers), __runInitializers(this, _initials_initializers, void 0)));
            _SdsAvatar_acronym_accessor_storage.set(this, (__runInitializers(this, _initials_extraInitializers), __runInitializers(this, _acronym_initializers, void 0)));
            _SdsAvatar_name_accessor_storage.set(this, (__runInitializers(this, _acronym_extraInitializers), __runInitializers(this, _name_initializers, void 0)));
            _SdsAvatar_text_accessor_storage.set(this, (__runInitializers(this, _name_extraInitializers), __runInitializers(this, _text_initializers, void 0)));
            _SdsAvatar_subtext_accessor_storage.set(this, (__runInitializers(this, _text_extraInitializers), __runInitializers(this, _subtext_initializers, void 0)));
            _SdsAvatar_role_accessor_storage.set(this, (__runInitializers(this, _subtext_extraInitializers), __runInitializers(this, _role_initializers, void 0)));
            _SdsAvatar_href_accessor_storage.set(this, (__runInitializers(this, _role_extraInitializers), __runInitializers(this, _href_initializers, void 0)));
            _SdsAvatar_src_accessor_storage.set(this, (__runInitializers(this, _href_extraInitializers), __runInitializers(this, _src_initializers, void 0)));
            _SdsAvatar_status_accessor_storage.set(this, (__runInitializers(this, _src_extraInitializers), __runInitializers(this, _status_initializers, void 0)));
            _SdsAvatar_count_accessor_storage.set(this, (__runInitializers(this, _status_extraInitializers), __runInitializers(this, _count_initializers, void 0)));
            _SdsAvatar_selected_accessor_storage.set(this, (__runInitializers(this, _count_extraInitializers), __runInitializers(this, _selected_initializers, false)));
            _SdsAvatar_disabled_accessor_storage.set(this, (__runInitializers(this, _selected_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            this.setPrimaryFieldHighlight = (__runInitializers(this, _disabled_extraInitializers), undefined);
            this.setSecondaryFieldHighlight = undefined;
            this.getHighlightClass = undefined;
            /**
             * Avatar size
             * @attr
             */
            this._size = 'lg';
            this._iconSize = 24;
            // endregion
        }
        /**
         * Avatar icon
         * @attr
         */
        get icon() { return __classPrivateFieldGet(this, _SdsAvatar_icon_accessor_storage, "f"); }
        set icon(value) { __classPrivateFieldSet(this, _SdsAvatar_icon_accessor_storage, value, "f"); }
        /**
         * Initials or Acronym of this avatar
         * @attr
         */
        get initials() { return __classPrivateFieldGet(this, _SdsAvatar_initials_accessor_storage, "f"); }
        set initials(value) { __classPrivateFieldSet(this, _SdsAvatar_initials_accessor_storage, value, "f"); }
        get acronym() { return __classPrivateFieldGet(this, _SdsAvatar_acronym_accessor_storage, "f"); }
        set acronym(value) { __classPrivateFieldSet(this, _SdsAvatar_acronym_accessor_storage, value, "f"); }
        /**
         * Name or Text of this avatar
         * @attr
         */
        get name() { return __classPrivateFieldGet(this, _SdsAvatar_name_accessor_storage, "f"); }
        set name(value) { __classPrivateFieldSet(this, _SdsAvatar_name_accessor_storage, value, "f"); }
        get text() { return __classPrivateFieldGet(this, _SdsAvatar_text_accessor_storage, "f"); }
        set text(value) { __classPrivateFieldSet(this, _SdsAvatar_text_accessor_storage, value, "f"); }
        /**
         * Role or Subtext of this avatar
         * @attr
         */
        get subtext() { return __classPrivateFieldGet(this, _SdsAvatar_subtext_accessor_storage, "f"); }
        set subtext(value) { __classPrivateFieldSet(this, _SdsAvatar_subtext_accessor_storage, value, "f"); }
        get role() { return __classPrivateFieldGet(this, _SdsAvatar_role_accessor_storage, "f"); }
        set role(value) { __classPrivateFieldSet(this, _SdsAvatar_role_accessor_storage, value, "f"); }
        /**
         * Href of this avatar
         * @attr
         */
        get href() { return __classPrivateFieldGet(this, _SdsAvatar_href_accessor_storage, "f"); }
        set href(value) { __classPrivateFieldSet(this, _SdsAvatar_href_accessor_storage, value, "f"); }
        /**
         * Avatar image source
         * @attr
         */
        get src() { return __classPrivateFieldGet(this, _SdsAvatar_src_accessor_storage, "f"); }
        set src(value) { __classPrivateFieldSet(this, _SdsAvatar_src_accessor_storage, value, "f"); }
        /**
         * Avatar status
         * @attr
         */
        get status() { return __classPrivateFieldGet(this, _SdsAvatar_status_accessor_storage, "f"); }
        set status(value) { __classPrivateFieldSet(this, _SdsAvatar_status_accessor_storage, value, "f"); }
        /**
         * Count of Avatars
         *
         * Example of use:
         * Used only for avatars group when avatars length more than 6 items
         *
         * @attr
         */
        get count() { return __classPrivateFieldGet(this, _SdsAvatar_count_accessor_storage, "f"); }
        set count(value) { __classPrivateFieldSet(this, _SdsAvatar_count_accessor_storage, value, "f"); }
        /**
         * If this attribute is true then avatar is selected
         */
        get selected() { return __classPrivateFieldGet(this, _SdsAvatar_selected_accessor_storage, "f"); }
        set selected(value) { __classPrivateFieldSet(this, _SdsAvatar_selected_accessor_storage, value, "f"); }
        /**
         * If this attribute is true then avatar is disabled
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsAvatar_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsAvatar_disabled_accessor_storage, value, "f"); }
        get size() {
            return this._size;
        }
        set size(value) {
            const oldValue = this._size;
            this._size = value;
            this.requestUpdate('size', oldValue);
            value === 'sm' ? (this._iconSize = 16) : (this._iconSize = 24);
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            // Preserve backward compatibility by assigning old properties to the new ones
            if (this.text) {
                this.name = this.text;
            }
            if (this.subtext) {
                this.role = this.subtext;
            }
            if (this.initials) {
                this.acronym = this.initials;
            }
        }
        render() {
            return html `
            <div class="${this.getClasses()}">${this.getFrame()} ${this.getContent()}</div>
        `;
        }
        // region search item implementation
        getPrimaryField() {
            return this.name;
        }
        getSecondaryField() {
            return this.role;
        }
        applySearchAndReturnSortInfo(searchFilter) {
            return applySearchAndReturnSortInfo(this, searchFilter);
        }
        getClasses() {
            return classMap({
                'sds-avatar': true,
                'sds-avatar--xl': this.size == 'xl',
                'sds-avatar--lg': this.size == 'lg',
                'sds-avatar--md': this.size == 'md',
                'sds-avatar--sm': this.size == 'sm',
                'sds-avatar--icon': this.icon,
                'sds-avatar--link': this.href,
                'sds-avatar--selected': this.selected,
                'sds-avatar--disabled': this.disabled,
                'sds-avatar--status-active': this.status === 'active',
                'sds-avatar--status-inactive': this.status === 'inactive',
            });
        }
        getInitials() {
            if (this.acronym) {
                return this.acronym.split(/\s/).reduce((response, word) => (response += word.slice(0, 1)), '');
            }
            return this.initials ? this.initials : this.name.split(/\s/).reduce((response, word) => (response += word.slice(0, 1)), '');
        }
        getFrame() {
            return html ` <div class="sds-avatar__frame" part="sds-avatar__frame">
            ${this.count
                ? html `+${this.count}`
                : this.src
                    ? html `<img src="${this.src}" alt="${this.name}" />`
                    : this.icon
                        ? html ` <sds-icon size="${this._iconSize}" name="${this.icon}"></sds-icon>`
                        : html `${this.getInitials()}`}
        </div>`;
        }
        getContent() {
            return html `${(this.name || this.role) &&
                html ` <div class="sds-avatar__content">${this.getName()} ${this.getRole()}</div>`}`;
        }
        getName() {
            return html `${(this.name && this.size != 'xl' && this.getNameStructure()) || ''}`;
        }
        getNameStructure() {
            return html `${(this.href &&
                html `<a href="${(this.disabled && '#') || this.href}" class="sds-avatar__name">
                <sds-clipped-text text="${this.name}" basic></sds-clipped-text>
            </a>`) ||
                html `
            <div class="sds-avatar__name">
                <sds-clipped-text text="${this.name}" basic></sds-clipped-text>
            </div>
        `}`;
        }
        getRole() {
            return html `
            ${(this.role &&
                this.size != 'xl' &&
                html `
                    <div class="sds-avatar__role">
                        <sds-clipped-text text="${this.role}" basic></sds-clipped-text>
                    </div>
                `) ||
                ''}
        `;
        }
    };
    _SdsAvatar_icon_accessor_storage = new WeakMap();
    _SdsAvatar_initials_accessor_storage = new WeakMap();
    _SdsAvatar_acronym_accessor_storage = new WeakMap();
    _SdsAvatar_name_accessor_storage = new WeakMap();
    _SdsAvatar_text_accessor_storage = new WeakMap();
    _SdsAvatar_subtext_accessor_storage = new WeakMap();
    _SdsAvatar_role_accessor_storage = new WeakMap();
    _SdsAvatar_href_accessor_storage = new WeakMap();
    _SdsAvatar_src_accessor_storage = new WeakMap();
    _SdsAvatar_status_accessor_storage = new WeakMap();
    _SdsAvatar_count_accessor_storage = new WeakMap();
    _SdsAvatar_selected_accessor_storage = new WeakMap();
    _SdsAvatar_disabled_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsAvatar");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _icon_decorators = [property({ type: String })];
        _initials_decorators = [property({ type: String })];
        _acronym_decorators = [property({ type: String })];
        _name_decorators = [property({ type: String })];
        _text_decorators = [property({ type: String })];
        _subtext_decorators = [property({ type: String })];
        _role_decorators = [property({ type: String })];
        _href_decorators = [property({ type: String })];
        _src_decorators = [property({ type: String })];
        _status_decorators = [property({ type: String })];
        _count_decorators = [property({ type: String })];
        _selected_decorators = [property({ type: Boolean })];
        _disabled_decorators = [property({ type: Boolean })];
        _set_size_decorators = [property({
                type: String,
                hasChanged: (newVal) => {
                    if (!availableSizes.includes(newVal)) {
                        console.error(`Unexpected Size ${newVal}`);
                        return false;
                    }
                    else {
                        return true;
                    }
                },
            })];
        __esDecorate(_classThis, null, _icon_decorators, { kind: "accessor", name: "icon", static: false, private: false, access: { has: obj => "icon" in obj, get: obj => obj.icon, set: (obj, value) => { obj.icon = value; } }, metadata: _metadata }, _icon_initializers, _icon_extraInitializers);
        __esDecorate(_classThis, null, _initials_decorators, { kind: "accessor", name: "initials", static: false, private: false, access: { has: obj => "initials" in obj, get: obj => obj.initials, set: (obj, value) => { obj.initials = value; } }, metadata: _metadata }, _initials_initializers, _initials_extraInitializers);
        __esDecorate(_classThis, null, _acronym_decorators, { kind: "accessor", name: "acronym", static: false, private: false, access: { has: obj => "acronym" in obj, get: obj => obj.acronym, set: (obj, value) => { obj.acronym = value; } }, metadata: _metadata }, _acronym_initializers, _acronym_extraInitializers);
        __esDecorate(_classThis, null, _name_decorators, { kind: "accessor", name: "name", static: false, private: false, access: { has: obj => "name" in obj, get: obj => obj.name, set: (obj, value) => { obj.name = value; } }, metadata: _metadata }, _name_initializers, _name_extraInitializers);
        __esDecorate(_classThis, null, _text_decorators, { kind: "accessor", name: "text", static: false, private: false, access: { has: obj => "text" in obj, get: obj => obj.text, set: (obj, value) => { obj.text = value; } }, metadata: _metadata }, _text_initializers, _text_extraInitializers);
        __esDecorate(_classThis, null, _subtext_decorators, { kind: "accessor", name: "subtext", static: false, private: false, access: { has: obj => "subtext" in obj, get: obj => obj.subtext, set: (obj, value) => { obj.subtext = value; } }, metadata: _metadata }, _subtext_initializers, _subtext_extraInitializers);
        __esDecorate(_classThis, null, _role_decorators, { kind: "accessor", name: "role", static: false, private: false, access: { has: obj => "role" in obj, get: obj => obj.role, set: (obj, value) => { obj.role = value; } }, metadata: _metadata }, _role_initializers, _role_extraInitializers);
        __esDecorate(_classThis, null, _href_decorators, { kind: "accessor", name: "href", static: false, private: false, access: { has: obj => "href" in obj, get: obj => obj.href, set: (obj, value) => { obj.href = value; } }, metadata: _metadata }, _href_initializers, _href_extraInitializers);
        __esDecorate(_classThis, null, _src_decorators, { kind: "accessor", name: "src", static: false, private: false, access: { has: obj => "src" in obj, get: obj => obj.src, set: (obj, value) => { obj.src = value; } }, metadata: _metadata }, _src_initializers, _src_extraInitializers);
        __esDecorate(_classThis, null, _status_decorators, { kind: "accessor", name: "status", static: false, private: false, access: { has: obj => "status" in obj, get: obj => obj.status, set: (obj, value) => { obj.status = value; } }, metadata: _metadata }, _status_initializers, _status_extraInitializers);
        __esDecorate(_classThis, null, _count_decorators, { kind: "accessor", name: "count", static: false, private: false, access: { has: obj => "count" in obj, get: obj => obj.count, set: (obj, value) => { obj.count = value; } }, metadata: _metadata }, _count_initializers, _count_extraInitializers);
        __esDecorate(_classThis, null, _selected_decorators, { kind: "accessor", name: "selected", static: false, private: false, access: { has: obj => "selected" in obj, get: obj => obj.selected, set: (obj, value) => { obj.selected = value; } }, metadata: _metadata }, _selected_initializers, _selected_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _set_size_decorators, { kind: "setter", name: "size", static: false, private: false, access: { has: obj => "size" in obj, set: (obj, value) => { obj.size = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsAvatar = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsAvatar = _classThis;
})();
export { SdsAvatar };
